import React from 'react'
import Submission from '../../Components/tutor/successpage/Submission'
function SuccessPage() {
  return (
    <div>
      <Submission/>
    </div>
  )
}

export default SuccessPage
